import { makeHttpRequest } from "@/shared";

export const deleteService = async (id) => {
    const response = (
        await makeHttpRequest({
            url: `/service/${id}`,
            method: "DELETE",
        })
    ).data;

    return response;
};
